import React from "react";

function insert(str: string, index: number, value: string) {
    return str.substr(0, index) + value + str.substr(index);
}
function minutesToTime(m: number): string {
    return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
}

interface TimeInputProps {
    label: string;
    name: string;
    value: any;
    type?: string;
    readOnly?: boolean;
    onChange: (value: any) => void
}
interface TimeInputState {
    value: string;
    type: string;
}
export class TimeInput extends React.Component<TimeInputProps, TimeInputState> {
    constructor(props: TimeInputProps) {
        super(props);
        this.state = {
            value: this.props.value,
            type: this.props.type ? this.props.type : "text"
        };
        this.handleChange = this.handleChange.bind(this);
    }

    static getDerivedStateFromProps(nextProps: TimeInputProps, prevState: TimeInputState): any {
        if (prevState.type !== nextProps.value) {
            return { value: nextProps.value };
        }
    }

    handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        let value = event.target.value;
        if (value && value !== this.state.value) {
            value = insert(String(value).replace(/[^0-9]/, ""), 2, ":");
            if (value.length === 5) {
                const [hs, ms] = value.split(":");
                let [h, m] = [parseInt(hs), parseInt(ms)];
                if (h > 24) h = 24;
                if (m > 59) m = 0;
                var minutes = (h * 60) + m;
                value = minutesToTime(minutes);
            }
            this.setState({ value });
            this.props.onChange(value);
        }
    }
    render() {
        return (
            <label>
                <span className="field">{this.props.label}</span>
                <input
                    name={this.props.name}
                    type={this.state.type}
                    value={this.state.value}
                    readOnly={this.props.readOnly}
                    placeholder={this.props.label}
                    onFocus={(e) => e.target.select()}
                    onChange={this.handleChange} maxLength={5} />
            </label>
        );
    }
}
